import { STATUS, PDF_CONSTANT } from "../constant";

const initState = {
  firstPage: {
    firstChartLoaded: false,
    secondChartLoaded: false,
    thirdChartLoaded: false,
    fourthChartLoaded: false
  },
  secondPage: {
    firstChartLoaded: false,
    secondChartLoaded: false,
    thirdChartLoaded: false,
    fourthChartLoaded: false,
    fifthChartLoaded: false
  },
  thirdPage: {
    firstChartLoaded: false,
    secondChartLoaded: false,
    thirdChartLoaded: false,
    fourthChartLoaded: false,
    fifthChartLoaded: false,
    sixthChartLoaded: false
  }
};

export const chartsReducer = (state = initState, action) => {
  switch (action.type) {
    case PDF_CONSTANT.FIRST_PAGE.FIRST._SUCCESS:
      return {
        ...state,
        firstPage: {
          ...state.firstPage,
          firstChartLoaded: true
        }
      };

    case PDF_CONSTANT.FIRST_PAGE.FIRST._FAILURE:
      return {
        ...state,
        firstPage: {
          ...state.firstPage,
          firstChartLoaded: false
        }
      };

    case PDF_CONSTANT.FIRST_PAGE.SECOND._SUCCESS:
      return {
        ...state,
        firstPage: {
          ...state.firstPage,
          secondChartLoaded: true
        }
      };

    case PDF_CONSTANT.FIRST_PAGE.SECOND._FAILURE:
      return {
        ...state,
        firstPage: {
          ...state.firstPage,
          secondChartLoaded: false
        }
      };

    case PDF_CONSTANT.FIRST_PAGE.THIRD._SUCCESS:
      return {
        ...state,
        firstPage: {
          ...state.firstPage,
          thirdChartLoaded: true
        }
      };

    case PDF_CONSTANT.FIRST_PAGE.THIRD._FAILURE:
      return {
        ...state,
        firstPage: {
          ...state.firstPage,
          thirdChartLoaded: false
        }
      };

    case PDF_CONSTANT.FIRST_PAGE.FOURTH._SUCCESS:
      return {
        ...state,
        firstPage: {
          ...state.firstPage,
          fourthChartLoaded: true
        }
      };

    case PDF_CONSTANT.FIRST_PAGE.FOURTH._FAILURE:
      return {
        ...state,
        firstPage: {
          ...state.firstPage,
          fourthChartLoaded: false
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.FIRST._SUCCESS:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          firstChartLoaded: true
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.FIRST._FAILURE:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          firstChartLoaded: false
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.SECOND._SUCCESS:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          secondChartLoaded: true
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.SECOND._FAILURE:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          secondChartLoaded: false
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.THIRD._SUCCESS:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          thirdChartLoaded: true
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.THIRD._FAILURE:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          thirdChartLoaded: false
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.FOURTH._SUCCESS:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          fourthChartLoaded: true
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.FOURTH._FAILURE:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          fourthChartLoaded: false
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.FIFTH._SUCCESS:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          fifthChartLoaded: true
        }
      };

    case PDF_CONSTANT.SECOND_PAGE.FIFTH._FAILURE:
      return {
        ...state,
        secondPage: {
          ...state.secondPage,
          fifthChartLoaded: false
        }
      };

    case PDF_CONSTANT.LAST_PAGE.FIRST._SUCCESS:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          firstChartLoaded: true
        }
      };

    case PDF_CONSTANT.LAST_PAGE.FIRST._FAILURE:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          firstChartLoaded: false
        }
      };

    case PDF_CONSTANT.LAST_PAGE.SECOND._SUCCESS:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          secondChartLoaded: true
        }
      };

    case PDF_CONSTANT.LAST_PAGE.SECOND._FAILURE:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          secondChartLoaded: false
        }
      };

    case PDF_CONSTANT.LAST_PAGE.THIRD._SUCCESS:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          thirdChartLoaded: true
        }
      };

    case PDF_CONSTANT.LAST_PAGE.THIRD._FAILURE:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          thirdChartLoaded: false
        }
      };

    case PDF_CONSTANT.LAST_PAGE.FOURTH._SUCCESS:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          fourthChartLoaded: true
        }
      };

    case PDF_CONSTANT.LAST_PAGE.FOURTH._FAILURE:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          fourthChartLoaded: false
        }
      };

    case PDF_CONSTANT.LAST_PAGE.FIFTH._SUCCESS:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          fifthChartLoaded: true
        }
      };

    case PDF_CONSTANT.LAST_PAGE.FIFTH._FAILURE:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          fifthChartLoaded: false
        }
      };

    case PDF_CONSTANT.LAST_PAGE.SIXTH._SUCCESS:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          sixthChartLoaded: true
        }
      };

    case PDF_CONSTANT.LAST_PAGE.SIXTH._FAILURE:
      return {
        ...state,
        thirdPage: {
          ...state.thirdPage,
          sixthChartLoaded: false
        }
      };

    case "CLEAR_PDF_REPORTS":
      return {
        ...initState
      };

    default:
      return state;
  }
};
